var Shopify = Shopify || {};
/* (J01, 3 Aug 2026) This line used to assign a hardcoded US-dollar money format
   unconditionally on every page, clobbering the GBP format Shopify sets from
   content_for_header. assets/cart-shipping-estimator.js:134 reads
   Shopify.money_format BEFORE its own pound-sign fallback, so shipping rates
   rendered in dollars on a UK cart.
   The shop's real format is emitted from Liquid by snippets/javascript-variables
   (theme.liquid:1237, inline in <head>); custom.js is deferred (:1402), so
   window.cartGlobal is always present by the time this runs. Assigning rather than
   deleting keeps money_format guaranteed-defined for this file's own formatMoney(),
   which falls back to it when no format argument is passed.
   NOTE: the old literal is deliberately NOT quoted here -- quoting removed code in
   comments is what makes grep-based audits report fixed defects as still present. */
Shopify.money_format = (window.cartGlobal && window.cartGlobal.money_format)
  || Shopify.money_format
  || '\u00A3{{amount}}';
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

(function($){
  if (!$ || !$.fn || !$.fn.on) { return; }
  $(function(){
  $(document).on('click','.open-variants',function(){
    $(this).toggleClass('opened');
    const variantGroup = $(this).siblings('.variants-group');
    if($(this).hasClass('opened')){
      $(this).text('Close');
      let height = 0;
      variantGroup.children().each(function(){
        height += $(this).height() + 10;
      })
      variantGroup.height(height).removeAttr('inert');
    }else{
      $(this).text('Choose options');
      variantGroup.height(0).attr('inert', '');
    }
  });

  //$(document).on('click','.open-account-popup',function(){
  //  $('.side-popup').removeClass('visible');
  //  $('.cart-drawer-wrapper').removeClass('active');
  //  $('body').removeClass('overflow-hidden');
  //  $('#account-popup').addClass('visible');
  //  $('#account-popup').find('.customer').hide();
  //  const section = $(this).attr('data-target');
  //  $('#account-popup').find(`.customer.${section}`).show();
  //});
  $(document).on('click','.recover-toggle',function(){
    $(this).parents('.customer').hide();
    $(this).parents('.customer').siblings('.recover').show();
  })
  $(document).on('click','.login-toggle',function(){
    $(this).parents('.customer').hide();
    $(this).parents('.customer').siblings('.login').show();
  })
  $(document).on('click','.signup-toggle',function(){
    $(this).parents('.customer').hide();
    $(this).parents('.customer').siblings('.register').show();
  })
  function formToJSON(elements) {
    return [].reduce.call(elements, function (data, element) {
      data[element.name] = element.value;
      return data;
    }, {});
  }
  function getUrlString(data) {
    var urlParameters = Object.entries(data).map(function (e) {
      return e.join('=');
    }).join('&');
  
    return urlParameters;
  } 
  $('#sidebar-recover').on('submit',function(event){
    event.preventDefault();
    const form = $(this);
    const action = form.attr("action");
    const inputs = form[0].querySelectorAll("[name]");
    fetch(action, {
			method: 'POST',
			body: getUrlString(formToJSON(inputs)),
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				'Accept': 'text/html, */*; q=0.01',
				'X-Requested-With': 'XMLHttpRequest'
			}
		}).then(function(response) {
      form.parents('.recover-form-wrapper').hide();
      form.parents('.recover-form-wrapper').siblings('.recover-success').html(`
        <p>Password reset link has been sent to your email. Please go back to login</p>
        <button type="button" class="login-toggle">Login</button>
      `)
		}).catch(function(err) {
			console.error(err);
		});
    
  })
  $(document).on('click','[href="#recover"]',function(){
    $('#recover').show();
    $('#login').hide();
  });$(document).on('click','[href="#login"]',function(){
    $('#login').show();
    $('#recover').hide();
  });

  $(document).on('click','#checkout-trigger',function(){
    $(this).attr('disabled','disabled').css('opacity','0.6');
    $('#checkout').trigger('click');
  });


  $(document).on('click','.popup-close,.popup-overlay',function(){
    $(this).parents('.side-popup').removeClass('visible');
  });



  let scrollTimeout = '';
  $(document).on('scroll',function(){
    if($('.cart-drawer-wrapper.added-to-cart').length){
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        $('.cart-drawer-wrapper.added-to-cart').find('.drawer__close').trigger('click');
      }, 500);
    }
  });
  
  if($('body').hasClass('template-cart')){
    if (typeof tick === 'function') { tick(); }
  }

  const addressSlider = document.querySelector('.address-blocks') ? new Swiper('.address-blocks', {
    slidesPerView: 4,
    spaceBetween: 30,
    draggable: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 1.3
      },
      640: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      1200: {
        slidesPerView: 4
      }
    }
  }) : null;
  $(document).on('click','.add-address',function(){
    $('.side-popup').removeClass('visible');
    $('#add-address').addClass('visible');
  });
  $(document).on('click','.edit-address',function(){
    $('.side-popup').removeClass('visible');
    $('#edit-address').addClass('visible');
    const id = $(this).parents('.address-block').attr('data-id');
    $('#edit-address').find('.edit-form').hide();
    const activeForm = $('#edit-address').find(`.edit-form#address_form_${id}`);
    activeForm.show();
    if(activeForm.find('[name="address[default]"]').attr('type') === 'hidden'){
      activeForm.find('[name="address[default]"]').attr('type','checkbox');
    }
  });

  $(document).on('submit','#address_form_new',function(event){
    event.preventDefault();
    const form = $(this);
    const action = form.attr("action");
    const inputs = form[0].querySelectorAll("[name]");
    const JSONData = formToJSON(inputs);
    form.addClass('disabled');
    fetch(action, {
			method: 'POST',
			body: getUrlString(JSONData),
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				'Accept': 'text/html, */*; q=0.01',
				'X-Requested-With': 'XMLHttpRequest'
			}
		}).then(response=>response.text()).then(function(data) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, "text/html");
      const bodyEl = doc.body;
      const addressList = bodyEl.querySelector('#address-list');
      const newSlides = addressList.querySelectorAll('.address-block');
      const editForm = bodyEl.querySelector('#address-edit').innerHTML;
      addressSlider.removeAllSlides();
      newSlides.forEach(function(c,i){
        addressSlider.appendSlide(c);
      });
      $('#editFormContainer').empty().append(editForm);
      $('#add-address').removeClass('visible');
      form.trigger("reset");
      form.removeClass('disabled');
		}).catch(function(err) {
			console.error(err);
		});
    
  })

  $(document).on('submit','form.edit-form',function(event){
    event.preventDefault();
    const form = $(this);
    const action = form.attr("action");
    const inputs = form[0].querySelectorAll("[name]");
    const JSONData = formToJSON(inputs);
    form.addClass('disabled');
    fetch(action, {
			method: 'POST',
			body: getUrlString(JSONData),
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				'Accept': 'text/html, */*; q=0.01',
				'X-Requested-With': 'XMLHttpRequest'
			}
		}).then(function(res) {
      fetch('/account/addresses', {
        method: 'GET'
      }).then(response=>response.text()).then(function(data) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");
        const bodyEl = doc.body;
        const addressList = bodyEl.querySelector('#address-list');
        const newSlides = addressList.querySelectorAll('.address-block');
        const editForm = bodyEl.querySelector('#address-edit').innerHTML;
        addressSlider.removeAllSlides();
        newSlides.forEach(function(c,i){
          addressSlider.appendSlide(c);
        });
        $('#editFormContainer').empty().append(editForm);
        $('#edit-address').removeClass('visible');
        form.removeClass('disabled');
      }).catch(function(err) {
        console.error(err);
      });
		}).catch(function(err) {
			console.error(err);
		});
  });

  $(document).on('click','.delete-address',function(event){
    const el = $(this)[0];
    const JSONData = {
      _method: 'delete'
    };
    const form = $(this).parents('form');
    form.addClass('disabled');
    if (confirm(el.getAttribute('data-confirm-message'))) {
      fetch(el.dataset.target, {
        method: 'POST',
        body: getUrlString(JSONData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Accept': 'text/html, */*; q=0.01',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(response=>response.text()).then(function(data) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");
        const bodyEl = doc.body;
        const addressList = bodyEl.querySelector('#address-list');
        const newSlides = addressList.querySelectorAll('.address-block');
        const editForm = bodyEl.querySelector('#address-edit').innerHTML;
        addressSlider.removeAllSlides();
        newSlides.forEach(function(c,i){
          addressSlider.appendSlide(c);
        });
        $('#edit-address').removeClass('visible');
        $('#editFormContainer').empty().append(editForm);
        form.removeClass('disabled');
      }).catch(function(err) {
        console.error(err);
      });

    }

  })

  $(document).on('change','#order-filter',function(){
    const selectEl = $(this);
    selectEl.attr('disabled','disabled');
    const month = $(this).find(':selected').text();
    fetch('/account?view=orders', {
      method: 'GET'
    }).then(response=>response.text()).then(function(data) {
      const perPage = 5;
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, "text/html");
      const bodyEl = doc.body;
      const orderList = bodyEl.querySelector('#order-list');
      const selectedOrders = $(orderList).find(`[data-month="${month}"]`);
      $('.order-history tbody').empty();
      $('#order-pagination').empty();
      if(selectedOrders.length > 0){
        selectedOrders.each(function(){
          $('.order-history tbody').append($(this));
        });
        $(`.order-history tbody tr:nth-child(n+${perPage+1})`).addClass('hidden');
        const pages = Math.ceil(selectedOrders.length / perPage);
        $('#order-pagination').attr('data-total',pages);
        if(pages > 1){
          $('#order-pagination').append(`<li class="hidden">
                                        <a href="javascript:void(0)" aria-label="Previous page" class="prev-order-page">
                                          <svg aria-hidden="true" focusable="false" viewBox="0 0 10 6">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                                          </path></svg>
                                        </a>
                                      </li>`);
          for(i=1;i<=pages;i++){
          if(i === 1){
            $('#order-pagination').append('<li><span aria-label="Page 1" data-page="1" class="current">1</span></li>');
          }else{
            $('#order-pagination').append(`<li><a href="javascript:void(0)" aria-label="Page ${i}" data-page="${i}">${i}</a></li>`);
          }
          }
          $('#order-pagination').append(`<li>
                                        <a href="javascript:void(0)" aria-label="Next page" class="next-order-page">
                                          <svg aria-hidden="true" focusable="false" viewBox="0 0 10 6">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                                          </path></svg>
                                        </a>
                                      </li>`);
          }
      }else{
        $('.order-history tbody').append(`<tr><td colspan=4 style="text-align: center;padding: 10px 0;">No orders on ${month}</td></tr>`);
      }
      selectEl.removeAttr('disabled');
    }).catch(function(err) {
      console.error(err);
    });
  })

  $(document).on('click','.next-order-page', function(e){
    e.preventDefault();
    $(this).attr("disabled", "disabled");
    const perPage = 5;
    const currentPage = $('#order-pagination').find('span.current');
    const currentLi = currentPage.parent();
    const currentPageIndex = parseInt(currentPage.text());
    const nextIndexStart = parseInt(currentPage.text()) * perPage +1;
    const nextIndexEnd = (currentPageIndex + 1) * perPage;
    const nextPage = currentPage.parents('li').next();
    const total = parseInt($('#order-pagination').attr('data-total'));

    nextPage.empty();
    nextPage.append(`<span aria-current="page" class="current" aria-label="Page ${currentPageIndex + 1}" data-page="${currentPageIndex + 1}">${currentPageIndex + 1}</span>`);

    currentLi.empty();
    currentLi.append(`<a href="javascript:void(0)" aria-label="Page ${currentPageIndex}" data-page="${currentPageIndex}">${currentPageIndex}</a>`);

    $('#order-pagination .prev-order-page').parent().removeClass('hidden');
    $(this).removeAttr("disabled");

    $('.order-history tbody tr:not(.hidden)').addClass('hidden');
    for(i=nextIndexStart;i<=nextIndexEnd;i++){
      $(`.order-history tbody tr:nth-child(${i})`).removeClass('hidden');
    }

    if(currentPageIndex + 1 >= total){
      $(this).parents('li').addClass('hidden')
    }

  })

  $(document).on('click','.prev-order-page', function(e){
    e.preventDefault();
    $(this).attr("disabled", "disabled");
    const perPage = 5;
    const currentPage = $('#order-pagination').find('span.current');
    const currentLi = currentPage.parent();
    const currentPageIndex = parseInt(currentPage.text());

    const nextIndexStart = (currentPageIndex - 1) * perPage;
    const nextIndexEnd = (currentPageIndex - 2) * perPage + 1;

    const prevPage = currentPage.parents('li').prev();
    const total = parseInt($('#order-pagination').attr('data-total'));

    prevPage.empty();
    prevPage.append(`<span aria-current="page" class="current" aria-label="Page ${currentPageIndex - 1}" data-page="${currentPageIndex - 1}">${currentPageIndex - 1}</span>`);

    currentLi.empty();
    currentLi.append(`<a href="javascript:void(0)" aria-label="Page ${currentPageIndex}" data-page="${currentPageIndex}">${currentPageIndex}</a>`);

    $('#order-pagination .next-order-page').parent().removeClass('hidden');
    $(this).removeAttr("disabled");

    $('.order-history tbody tr:not(.hidden)').addClass('hidden');
    for(i=nextIndexStart;i>=nextIndexEnd;i--){
      $(`.order-history tbody tr:nth-child(${i})`).removeClass('hidden');
    }

    if(currentPageIndex - 1 <= 1){
      $(this).parents('li').addClass('hidden')
    }

  });

  $(document).on('click','.reorder-button',function(){
    $('.side-popup').removeClass('visible');
    $('#reorder-popup').addClass('visible');
    const order_title = $(this).next().find('h1').text();
    const order_cart = $(this).next().find('.reorder-cart').html();
    const order_cart_footer = $(this).next().find('.reorder-total').html();
    
    $('#reorder-popup').find('.reorder-contents > .popup-title').text(order_title);
    $('#reorder-popup').find('.reorder-contents > #reorder-cart').html(order_cart);
    $('#reorder-popup').find('.reorder-contents > #reorder-cart-footer').html(order_cart_footer);
  });

  $(document).on('click','.reorder-button-submit',function(){
    const item = [];
    $('#reorder-popup .form-key').each(function(){
      const key = {
        'id': parseInt($(this).attr('data-id')),
        'quantity': parseInt($(this).attr('data-qty'))
      }
      item.push(key);
    });
    const formData = {
      'items':item
    }
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((response) => response.json())
    .then((response) => {
      if(response.status === 422){
        $('#reorder-form-error').text(response.description);
      }else{
        location.reload();
      }

    })
    .catch((error) => {
      $('#reorder-form-error').text(error.description);
    });


  })

  // Smooth-scroll for in-page anchors.
  // IMPORTANT: Product navigation pills ('.prod-nav-pill') have their own
  // offset-aware scrolling logic in the PDP navigation tabs section.
  // If we also handle them here, the fixed -80 offset can override the PDP
  // calculation and cause headings to land under the sticky ATC bar.
  $(document).on('click', 'a[href^="#"]', function (event) {
    if ($(this).hasClass('prod-nav-pill')) return;

    var href = $.attr(this, 'href');
    if (!href || href.length < 2) return;

    var $target = $(href);
    if (!$target.length || !$target.offset) return;

    event.preventDefault();

    // Keep legacy behaviour, but prefer the actual sticky header height when available.
    var headerH = $('.shopify-section-header-sticky, .section-header, header.header').first().outerHeight() || 0;
    var offset = Math.max(80, headerH);

    $('html, body').animate({
      scrollTop: $target.offset().top - offset
    }, 500);
  });


  

  });
})(window.jQuery);

/* Removed Jul 2026 (Task #46 / #50): the desktop nav drag/wheel horizontal-scroll
   IIFE that used to live here.  It existed only to make the 990-1440px top-level
   menu row draggable, which was itself only needed because the row was too wide
   to fit.  The row is now sized to fit (see assets/custom.css - nav label
   font-size in that band), so there is nothing to scroll and nothing to drag.
   This also removes the .nav-hscrolling class it set on <html> and the six
   wheel/pointer/click listeners it re-attached to the <ul> on every matchMedia
   change. */
